import { ApolloLink, concat, InMemoryCache } from '@apollo/client/core'
import { getGqlURL, getLocale } from 'src/common/functions'
import { createUploadLink } from 'apollo-upload-client'
import { Platform } from 'quasar'
import { onError } from '@apollo/client/link/error'
import { RetryLink } from '@apollo/client/link/retry'
import { ALLOW_MIRROR } from 'src/common/config'
import { useUserAuthStore } from 'src/stores/user/auth'

export function getClientOptions() {
  const config = {}
  const userAuthStore = useUserAuthStore()

  const uri = getGqlURL()

  const httpLink = createUploadLink({
    uri: ({ operationName }) => `${uri}?${operationName}`,
  })

  const authMiddleware = new ApolloLink((operation, forward) => {
    const JWT = userAuthStore.getToken ? `JWT ${userAuthStore.getToken}` : null
    const locale = userAuthStore.getUserLanguage || getLocale()

    const headers = {
      'client-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      accept: 'application/json',
      'Accept-Language': locale,
    }

    if (JWT && operation.operationName !== 'refreshToken') {
      headers.Authorization = JWT
    }

    const allowMirror = ALLOW_MIRROR.storage.getItem(ALLOW_MIRROR.query)
    if (JWT && allowMirror && operation.operationName === 'siteInfo') {
      headers[ALLOW_MIRROR.header] = 1
    }

    if (Platform.is.mobile) {
      headers.CASISMOBILE = 1
    }

    operation.setContext({ headers })
    return forward(operation)
  })

  const errorLink = onError(({ graphQLErrors, operation, networkError }) => {
    if (graphQLErrors) {
      const variables = Object.entries(operation.variables)
        .map(([key, value]) => `${key}:${value}`)
        .join(';')

      const description = `(${operation.operationName}${variables ? ' | ' + variables : ''})`
      const errors = graphQLErrors.map(({ message }) => message)

      console.error(`GQL errors: ${description}: ${errors.join(' | ')}`)
    }

    if (networkError) {
      console.error(`Network error [${operation.operationName}]. ${networkError.message}`)
    }
  })

  const retryLink = new RetryLink({
    delay: {
      initial: 3000,
      max: Infinity,
      jitter: true,
    },
    attempts: {
      max: 2,
      retryIf: (error) => !!error,
    },
  })

  config.cache = new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          siteInfo: {
            merge(existing, incoming) {
              return { ...existing, ...incoming }; // Объединяем данные
            },
          },
        },
      },
    },
  })

  config.link = ApolloLink.from([retryLink, errorLink, concat(authMiddleware, httpLink)])

  return config
}
